import React from 'react';
import Tabbar from 'Components/Tabbar';
import { Container, Row, Col } from 'Components/Grid';
import Button from 'Components/Button';
import styles from './styles.scss';
import { getGivenBackground } from 'Utils/getColor';

export default class InspectionProcess extends React.Component {
  render() {
    return (
      <Tabbar
        id={'inspectiontabs'}
        tabs={['Zu Beginn', 'Die Inspektion', 'Im Anschluss']}
        background={getGivenBackground('grey')}
      >
        <Container>
          <div className={styles.content}>
            <Row>
              <Col cols={12} m={6}>
                <img
                  src="/fileadmin/hws-content/inspektion/inspektion_schritt_1.png"
                  alt="Inspektion - Direktannahme & Vorbesprechung"
                />
              </Col>
              <Col cols={12} m={5}>
                <h5 className={styles.headline}>Direktannahme & Vorbesprechung</h5>
                <p>
                  Professionell heißt für uns: wir schauen uns Ihren Mazda ganz genau an, bevor wir
                  mit der Arbeit anfangen. Hier werden, gerne gemeinsam mit Ihnen, zahlreiche
                  Prüfpunkte durchgegangen und der Zustand des Fahrzeugs dokumentiert. Sollten
                  bestimmte Teile Verschleiß aufweisen, besprechen wir mit Ihnen vorab, ob diese
                  direkt ausgetauscht werden sollen. Alle Informationen stehen Ihnen danach in der
                  Direktannahme-Checkliste digital zur Verfügung.
                </p>
                <p>
                  Nachdem wir uns ein Bild über den Fahrzeugzustand gemacht haben, erhalten Sie
                  einen Kostenvoranschlag. Nun können wir mit der Arbeit anfangen.
                </p>
              </Col>
            </Row>
          </div>
        </Container>
        <Container>
          <div className={styles.content}>
            <Row>
              <Col cols={12} m={6}>
                <img
                  src="/fileadmin/hws-content/inspektion/inspektion_schritt_2.png"
                  alt="Inspektion - Während der Inspektion"
                />
              </Col>
              <Col cols={12} m={5}>
                <h5 className={styles.headline}>Während der Inspektion</h5>
                <p>
                  Eine Inspektion dauert je nach Inspektionspaket, Modell und Fahrzeugzustand
                  zwischen 30 Minuten und mehreren Stunden.
                  <br />
                  Währenddessen können Sie Ihre Wartezeit bei uns verbringen, oder Sie profitieren
                  von unseren attraktiven Mietwagenangeboten*. Ihre Mobilität wird in jedem Fall
                  sichergestellt.
                </p>
                <Button
                  label="Mobilitätsangebot"
                  href="/beratung-und-kauf/weitere-leistungen/mietwagenprogramm/"
                  type="secondary"
                />
                <p className={styles.footnoteText}>
                  * Nach Verfügbarkeit, ggf. können Kosten hierfür anfallen.
                </p>
              </Col>
            </Row>
          </div>
        </Container>
        <Container>
          <div className={styles.content}>
            <Row>
              <Col cols={12} m={6}>
                <img
                  src="/fileadmin/hws-content/inspektion/inspektion_schritt_3.png"
                  alt="Inspektion - Dokumentation & Rechnung"
                />
              </Col>
              <Col cols={12} m={5}>
                <h5 className={styles.headline}>Dokumentation & Rechnung</h5>
                <p>
                  Alle durchgeführten Arbeiten und Prüfpunkte sind für Sie auf unserer
                  Wartungscheckliste dokumentiert und verfügbar. Auf Wunsch erhalten Sie den
                  digitalen Service Nachweis auch gerne als Ausdruck für Ihre Unterlagen. Gerne
                  erklären wir Ihnen die Rechnung.
                </p>
              </Col>
            </Row>
          </div>
        </Container>
      </Tabbar>
    );
  }
}
